import './App.css';

/**
 * Renders an alert component with customizable content and level.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.level - The level of the alert, which determines its styling.
 * @param {string} props.content - The content to be displayed in the alert.
 * @returns {JSX.Element} A React component that displays an alert with the specified content and styling.
 */
function Alert(props) {

  return (
    <>
        <div className='alert-wrapper'>
            <div className={`alert ${props.level}`}>
                <p className='content'>{props.content}</p>
            </div>
        </div>
    </>
  );
}

export default Alert;